import { Stack, Typography } from "@mui/material";
import { CompletedIcon, NoValidIcon } from "../../../../images";

type Status = "not_valid" | "completed" | "already_connected";

const getMapper = (
  platform?: string,
): Record<Status, { title: string; text: string; icon: React.ReactNode }> => ({
  not_valid: {
    title: "Link Is No Longer Valid",
    text: "The link you followed is no longer active. No action is needed on your end.",
    icon: <NoValidIcon />,
  },
  completed: {
    title: "Import Complete",
    text:
      "Marketo is connected. The INFUSE Buying Committee Radar is pulling in your campaign data now." +
      " You can close this window.",
    icon: <CompletedIcon />,
  },
  already_connected: {
    title: "Already Connected",
    text: `${platform ? platform.charAt(0).toUpperCase() + platform.slice(1) : "CRM"} is already connected to this
     campaign. You can close this window.`,
    icon: <CompletedIcon />,
  },
});

type Props = {
  isCompleted?: boolean;
  isAlreadyConnected?: boolean;
  platform?: string;
};

export const NotificationMessageBlock = ({
  isCompleted,
  isAlreadyConnected,
  platform,
}: Props) => {
  const status: Status = isAlreadyConnected
    ? "already_connected"
    : isCompleted
      ? "completed"
      : "not_valid";
  const { title, text, icon } = getMapper(platform)[status];

  return (
    <Stack
      sx={{
        border: "1px solid #DEDEDE",
        borderRadius: "8px",
        padding: "64px",
        gap: "48px",
        alignItems: "flex-start",
        maxWidth: "600px",
      }}
    >
      {icon}
      <Stack gap="8px">
        <Typography variant="h1" sx={{ color: "#232323" }}>
          {title}
        </Typography>
        <Typography variant="subtitle1" sx={{ color: "#464646" }}>
          {text}
        </Typography>
      </Stack>
    </Stack>
  );
};
